module.exports = __webpack_public_path__ + "static/logo-01-e09e83a0f09bbb48473d465a516dbffc.svg";